/**
 * 安全存储工具
 */

const STORAGE_PREFIX = 'hmd_'
const MAX_STORAGE_AGE = 7 * 24 * 60 * 60 * 1000

function getStorageKey(key) {
  return STORAGE_PREFIX + key
}

function safeJSONParse(str, defaultValue = null) {
  try {
    if (typeof str !== 'string') {
      return str
    }
    return JSON.parse(str)
  } catch (e) {
    return defaultValue
  }
}

export function setStorage(key, value, options = {}) {
  try {
    const storageKey = getStorageKey(key)
    const data = {
      value,
      timestamp: Date.now(),
      ttl: options.ttl || MAX_STORAGE_AGE
    }
    localStorage.setItem(storageKey, JSON.stringify(data))
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (e) {
    }
    return true
  } catch (e) {
    return false
  }
}

export function getStorage(key, defaultValue = null) {
  try {
    const storageKey = getStorageKey(key)
    let stored = localStorage.getItem(storageKey)
    
    if (!stored) {
      stored = localStorage.getItem(key)
    }
    
    if (!stored) {
      return defaultValue
    }
    
    const data = safeJSONParse(stored)
    if (data && typeof data === 'object' && data.value !== undefined) {
      if (data.timestamp && data.ttl) {
        if (Date.now() - data.timestamp > data.ttl) {
          removeStorage(key)
          return defaultValue
        }
      }
      return data.value
    } else {
      return safeJSONParse(stored, stored)
    }
  } catch (e) {
    return defaultValue
  }
}

export function removeStorage(key) {
  try {
    const storageKey = getStorageKey(key)
    localStorage.removeItem(storageKey)
    localStorage.removeItem(key)
    return true
  } catch (e) {
    return false
  }
}

export function clearAllStorage() {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i)
      if (key && key.startsWith(STORAGE_PREFIX)) {
        localStorage.removeItem(key)
      }
    }
    return true
  } catch (e) {
    return false
  }
}

export function getStorageInfo() {
  try {
    const keys = []
    for (let i = 0; i < localStorage.length; i++) {
      keys.push(localStorage.key(i))
    }
    return { keys }
  } catch (e) {
    return null
  }
}

export function setSecureStorage(key, value) {
  return setStorage(key, value, { ttl: MAX_STORAGE_AGE })
}

export function getSecureStorage(key, defaultValue = null) {
  return getStorage(key, defaultValue)
}

export const safeStorage = {
  set: setStorage,
  get: getStorage,
  remove: removeStorage,
  clear: clearAllStorage,
  info: getStorageInfo,
  setSecure: setSecureStorage,
  getSecure: getSecureStorage
}

export default safeStorage
